import { NgModule } from '@angular/core'
import {
  AuthConfig,
  AuthHttpHeaderService,
  OAuthLibWrapperService,
  provideConfig
} from '@spartacus/core'
import { MbOauthLibWrapperService } from './services/mb-oauth-lib-wrapper.service'
import { environment } from '../../../environments/environment'
import { MbAuthHttpHeaderService } from './services/mb-auth-http-header.service'

const {
  clientId,
  clientSecret,
  scope,
  oauthUrl,
  authorizePath,
  tokenPath,
  revokePath,
  logoutPath,
  userInfoPath,
  disablePKCE
} = environment.oAuth || {}

@NgModule({
  providers: [
    {
      provide: OAuthLibWrapperService,
      useExisting: MbOauthLibWrapperService
    },
    {
      provide: AuthHttpHeaderService,
      useExisting: MbAuthHttpHeaderService
    },
    provideConfig({
      authentication: {
        ...clientId ? { client_id: clientId } : {},
        ...clientSecret ? { client_secret: clientSecret } : {},
        ...oauthUrl ? { baseUrl: oauthUrl } : {},
        ...tokenPath ? { tokenEndpoint: tokenPath } : {},
        ...revokePath ? { revokeEndpoint: revokePath } : {},
        ...authorizePath ? { loginUrl: authorizePath } : {},
        ...logoutPath ? { logoutUrl: logoutPath } : {},
        ...userInfoPath ? { userInfoEndpoint: userInfoPath } : {},
        OAuthLibConfig: {
          ...scope ? { scope } : {},
          responseType: 'id_token token',
          oidc: true,
          disablePKCE: true === disablePKCE
        }
      }
    } as AuthConfig),
  ]
})
export class AuthModule {
}
